import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/sections/Hero';
import { Transformation } from './components/sections/Transformation';
import { PainPoints } from './components/sections/PainPoints';
import { Volumes } from './components/sections/Volumes';
import { Tools } from './components/sections/Tools';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { Author } from './components/sections/Author';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { usePastElement } from './hooks/usePastElement';
export function App() {
  const {
    ref: heroCtaRef,
    past
  } = usePastElement<HTMLAnchorElement>();
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream font-sans text-navy-900" data-id="element-0" data-mp="3mlaxj7fckftz">
      <MetaPixel data-id="element-1" data-mp="3rcj6y3gog175" />
      <main data-id="element-2" data-mp="3rbzmaezn6ypf">
        <Hero ctaRef={heroCtaRef} data-id="element-3" data-mp="3rdarmj8qkein" />
        <Transformation data-id="element-4" data-mp="3recd7hndojem" />
        <PainPoints data-id="element-5" data-mp="5ot150vj28n" />
        <Volumes data-id="element-6" data-mp="680tswt8a8y" />
        <Tools data-id="element-7" data-mp="4n5w26l2pak" />
        <Bonuses data-id="element-8" data-mp="56mnfkhz7n0" />
        <Offer data-id="element-9" data-mp="7suzhf7pr6a" />
        <Guarantee data-id="element-10" data-mp="2zld1d7i6tbah" />
        <Testimonials data-id="element-11" data-mp="2zlv7cvunj3vl" />
        <Author data-id="element-12" data-mp="2zmemy5wtxg6g" />
        <Faq data-id="element-13" data-mp="2zmwhmy3ufmc9" />
        <FinalCta data-id="element-14" data-mp="2zng0qi58cgrv" />
      </main>
      <Footer data-id="element-15" data-mp="33m5ck6amdq9e" />
      <FloatingCta visible={past} data-id="element-16" data-mp="33nq73vwxp979" />
      <PurchasePopup data-id="element-17" data-mp="33myjb79kwfrj" />
    </div>;
}